import React from 'react';
import { createRoot } from 'react-dom/client';
import { AdminEmailAnalyticsPage, type AdminEmailAnalyticsPageProps } from '../ui/admin/AdminEmailAnalyticsPage';

export function AdminEmailAnalyticsPageContainer(props: AdminEmailAnalyticsPageProps) {
  return <AdminEmailAnalyticsPage {...props} />;
}

export function mountAdminEmailAnalyticsPage(
  container: HTMLElement,
  props: AdminEmailAnalyticsPageProps
) {
  const root = createRoot(container);
  root.render(<AdminEmailAnalyticsPageContainer {...props} />);
  return root;
}

export default AdminEmailAnalyticsPageContainer;
